// Telegram Mini App helpers (no-op when not in Telegram)

export function tgWebApp() {
  return typeof window !== "undefined" ? window.Telegram?.WebApp : undefined;
}

export const isTelegram = () => !!tgWebApp()?.initData;

export function haptic(kind: "impact" | "success" | "warning" | "error" | "selection" = "impact") {
  const tg = tgWebApp() as any;
  if (!tg?.HapticFeedback) return;
  try {
    if (kind === "selection") tg.HapticFeedback.selectionChanged();
    else if (kind === "impact") tg.HapticFeedback.impactOccurred("medium");
    else tg.HapticFeedback.notificationOccurred(kind);
  } catch {}
}

export function setMainButton(opts: {
  text: string;
  visible?: boolean;
  onClick?: () => void;
  loading?: boolean;
}) {
  const tg = tgWebApp() as any;
  if (!tg?.MainButton) return () => {};
  tg.MainButton.setText(opts.text);
  if (opts.loading) tg.MainButton.showProgress(false);
  else tg.MainButton.hideProgress();
  if (opts.visible !== false) tg.MainButton.show();
  else tg.MainButton.hide();
  if (opts.onClick) {
    tg.MainButton.offClick();
    tg.MainButton.onClick(opts.onClick);
  }
  return () => {
    tg.MainButton?.hide();
    tg.MainButton?.offClick();
  };
}

export function setBackButton(handler: (() => void) | null) {
  const tg = tgWebApp() as any;
  if (!tg?.BackButton) return () => {};
  if (handler) {
    tg.BackButton.show();
    tg.BackButton.offClick();
    tg.BackButton.onClick(handler);
  } else {
    tg.BackButton.hide();
  }
  return () => {
    tg.BackButton?.hide();
    tg.BackButton?.offClick();
  };
}

export function timeAgo(iso: string | null): string {
  if (!iso) return "chưa đồng bộ";
  const diff = Date.now() - new Date(iso).getTime();
  if (diff < 0) return "vừa đồng bộ";
  const s = Math.floor(diff / 1000);
  if (s < 60) return `${s}s trước`;
  const m = Math.floor(s / 60);
  if (m < 60) return `${m} phút trước`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h} giờ trước`;
  const d = Math.floor(h / 24);
  return `${d} ngày trước`;
}
